import { useEffect, useState } from "react";
import { api } from "@/lib/api-client";

export interface VisibleTeam { id: string; name: string; parentTeamId: string | null }

/** Scope-filtered team list for pickers (GET /api/teams — server applies
 * resolveTeamScope). Empty for teamless viewers and zero-teams tenants. */
export function useVisibleTeams() {
  const [teams, setTeams] = useState<VisibleTeam[]>([]);
  useEffect(() => {
    let alive = true;
    api.get<{ teams: VisibleTeam[] }>("/teams")
      .then((r) => { if (alive) setTeams(r.teams); })
      .catch(() => { /* picker degrades to empty — non-fatal */ });
    return () => { alive = false; };
  }, []);
  return { teams };
}
